import '.g{display:flex;}.ssr-plugin'
import '.h{flex-direction:column;}.ssr-plugin'
import '.ax{flex:1 1 0;}.ssr-plugin'
import '.ay{min-width:0px;}.ssr-plugin'
import { Property } from 'csstype'
import { Style, styled } from 'inlines'
import { ReactNode } from 'react'

export type ColumnProps = {
  gap?: Property.Gap<(string & {}) | 0>
  alignItems?: Property.AlignItems
  style?: Style
  children: ReactNode
  onClick?: () => void
}

const Column = ({
  gap = '1rem',
  alignItems = 'flex-start',
  style,
  children,
  onClick,
}: ColumnProps) => {
  return (
    <styled.div className="g h ax ay"
      onClick={onClick}
      style={{
        alignItems,
        gap,
        ...style,
      }}
    >
      {children}
    </styled.div>
  )
}

export default Column
